import React        from 'react';
import BrandPlay    from 'components/brand_play';

export default React.createClass({
  render() {
    return (
      <BrandPlay descriptorJSON={window.bpInstance} />
    );
  }
});



// WEBPACK FOOTER //
// ./modules/components/App.js